import { Button, Modal, ModalBody, ModalFooter } from '@eleveo/components-react';
import React from 'react';

import { TEST_IDS } from '../../constants/dataTestIds';

export type WarningModalProps = {
  isOpen: boolean;
  title: string;
  cancelCaption: string;
  acceptCaption: string;
  onAccept?: () => void;
  onCancel?: () => void;
};

export const WarningModal: React.FC<React.PropsWithChildren<WarningModalProps>> = ({
  title,
  cancelCaption,
  acceptCaption,
  isOpen,
  onAccept,
  onCancel,
  children,
}) => (
  <Modal onClose={onCancel} title={title} isOpen={isOpen}>
    <ModalBody>{children}</ModalBody>
    <ModalFooter>
      <Button onClick={onCancel} variant="outline" testId={TEST_IDS.buttonModalCancel}>
        {cancelCaption}
      </Button>
      <Button color="error" onClick={onAccept} testId={TEST_IDS.buttonModalAccept}>
        {acceptCaption}
      </Button>
    </ModalFooter>
  </Modal>
);
